import * as z from 'zod'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'
import { toStandardSchema } from '../utils/schema'

export const HARMONY_WORKITEM_TABLE = '"public"."harmonyWorkitems"'
export const HARMONY_WORKITEM_ENDPOINT = '/api/harmony-workitem'

const harmonyWorkitemBaseSchema = z.object({
  id: z.string().min(5, 'Workitem ID is required').default('-----'),
  harmony_package_id: z.string().min(1, 'Package ID is required'),
  workitem_id: z.string().min(1, 'Workitem ID is required'),
  workspace_id: z.string().min(1, 'Workspace ID is required').optional(),
})

export const HarmonyWorkitemSchema = toStandardSchema(harmonyWorkitemBaseSchema)

export const HarmonyWorkitemConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_WORKITEM_TABLE,
  partitionKey: 'harmony_package_id',
  key: 'id',
  apiEndpoint: HARMONY_WORKITEM_ENDPOINT,
  where: {},
  schema: HarmonyWorkitemSchema,
}
